module.exports = "https://cdn.realtymogul.com/static/media/social_twitter_blue.aba609ad.svg";